import { 
  Sun, Moon, Cloud, CloudRain, CloudSnow, CloudLightning, 
  CloudDrizzle, CloudFog, Wind 
} from "lucide-react";

const iconMap = {
  "01d": { icon: Sun, color: "#ccff00" },
  "01n": { icon: Moon, color: "#7000ff" },
  "02d": { icon: Cloud, color: "#00f2ea" },
  "02n": { icon: Cloud, color: "#7000ff" },
  "03d": { icon: Cloud, color: "#a1a1aa" },
  "03n": { icon: Cloud, color: "#a1a1aa" },
  "04d": { icon: Cloud, color: "#71717a" },
  "04n": { icon: Cloud, color: "#71717a" },
  "09d": { icon: CloudDrizzle, color: "#00f2ea" },
  "09n": { icon: CloudDrizzle, color: "#00f2ea" },
  "10d": { icon: CloudRain, color: "#00a8e8" },
  "10n": { icon: CloudRain, color: "#00a8e8" },
  "11d": { icon: CloudLightning, color: "#ccff00" },
  "11n": { icon: CloudLightning, color: "#ccff00" },
  "13d": { icon: CloudSnow, color: "#fafafa" },
  "13n": { icon: CloudSnow, color: "#fafafa" },
  "50d": { icon: CloudFog, color: "#a1a1aa" },
  "50n": { icon: CloudFog, color: "#a1a1aa" },
};

export const WeatherIcon = ({ code, size = 48, className = "" }) => {
  const config = iconMap[code] || { icon: Cloud, color: "#a1a1aa" };
  const Icon = config.icon;
  
  return (
    <div 
      className={`relative ${className}`}
      style={{ width: size, height: size }}
    >
      <div 
        className="absolute inset-0 rounded-full blur-xl opacity-30"
        style={{ backgroundColor: config.color }}
      />
      <Icon 
        style={{ width: size, height: size, color: config.color }}
        strokeWidth={1.5}
      />
    </div>
  );
};

export default WeatherIcon;
